import React from 'react';
import { concatClassName } from '@dateam/ark-react';
import propTypes from 'prop-types';
import styles from './Page.module.scss';

type Props = {
    className?: string;
    children?: React.ReactNode;
};

const PageHeader: React.FC<Props> = ({
    className,
    children
}: Props) => (
    <div className={concatClassName(styles['header'], className)}>
        {children}
    </div>
);

PageHeader.propTypes = {
    className: propTypes.string,
    children: propTypes.node
};

PageHeader.defaultProps = {
    className: undefined,
    children: undefined
};

export default PageHeader;
